import React from 'react';
import { Box, Button, Typography, Container } from '@mui/material';
import TaxiAlertIcon from '@mui/icons-material/TaxiAlert';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants/route-constants';
import PropTypes from 'prop-types';
import { getItem } from '../../utils/helpers/storage-crud';
import { trackWebViewEvents } from '../../tracking/webview-tracking';

const NoDataFound = ({ message = 'Oops! something went wrong, please contact your RM.' }) => {
    const navigate = useNavigate();
    const isWebView = getItem('isWebView');
    const handleClick = () => {
        if (isWebView) {
            trackWebViewEvents('deepLink', {
                data: `cars24aepartner://?path=auction&tab=explore`,
            });
            return;
        }
        navigate(ROUTE_PATH.HOME);
    };

    return (
        <Container maxWidth="sm" sx={{ height: '100vh' }}>
            <Box className='h-full w-full flex flex-col justify-center items-center'>
                <TaxiAlertIcon className='h-40 w-40 px-16  text-primary' />
                <Typography variant="h6" className='px-8 text-center mt-8 text-border'>
                    {message}
                </Typography>
                <Button color='secondary' variant="contained" className='font-bold p-3 mt-8 w-40' onClick={handleClick}>Go to home</Button>
            </Box>
        </Container>
    );
};
NoDataFound.propTypes = {
    message: PropTypes.string
};
export default NoDataFound;
